
import { useSearchParams, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ClienteEnergiaForm from "@/components/clientes/ClienteEnergiaForm";
import ClienteSolarForm from "@/components/clientes/ClienteSolarForm";
import ClienteImporter from "@/components/clientes/ClienteImporter";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const ClienteNovo = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const geradorId = searchParams.get("gerador");
  const defaultTab = searchParams.get("tab") || "energia";

  return (
    <Layout>
      <div className="space-y-6 max-w-5xl mx-auto">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-energy-blue-dark">Novo Cliente</h1>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => navigate("/energia")} 
            className="flex items-center gap-2 bg-primary/10 hover:bg-primary/20 text-primary-foreground"
          >
            <ArrowLeft className="h-4 w-4" /> Voltar para Energia
          </Button>
        </div>
        
        <Tabs defaultValue={defaultTab} className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="energia">Cliente Energia</TabsTrigger>
            <TabsTrigger value="solar">Cliente Solar</TabsTrigger>
            <TabsTrigger value="importar">Importar Clientes</TabsTrigger>
          </TabsList>
          
          <TabsContent value="energia">
            <ClienteEnergiaForm geradorIdPreSelecionado={geradorId || undefined} />
          </TabsContent>
          
          <TabsContent value="solar">
            <ClienteSolarForm />
          </TabsContent>
          
          <TabsContent value="importar">
            <ClienteImporter />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default ClienteNovo;
